export const REVALIDATION_SECRET = 'pimsterrevalidation';
export const REVALIDATION_HEADER = 'X-Revalidation-Secret';
